import { render } from "./QuestionNavigator.vue?vue&type=template&id=4e1508c4&scoped=true&ts=true"
import script from "./QuestionNavigator.vue?vue&type=script&lang=ts"
export * from "./QuestionNavigator.vue?vue&type=script&lang=ts"

import "./QuestionNavigator.vue?vue&type=style&index=0&id=4e1508c4&scoped=true&lang=css"

import exportComponent from "/builds/edtechqc/front-end/next-front/eduqc-front-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1508c4"]])

export default __exports__
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';import TouchPan from 'quasar/src/directives/TouchPan.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPageSticky,QCard,QList,QItem,QItemSection,QItemLabel,QIcon,QSeparator});qInstall(script, 'directives', {TouchPan});
